import request from "./curl";
import chatgrp_edit from "../components/chatgrp_edit";
import group_action_dialog from "../components/group_action_dialog";
import chatgrp_participant_search  from "../components/chatgrp_participant_search";
import utility from "./utility";
import media_utility from "./media_utility";
import notification_dialog from "../components/notification_dialog";
import notification_utility from "./notification_utility";

import {
  Facebook,
  Twitter,
  Linkedin,
  Reddit,
  Telegram,
  WhatsApp,
  Email
} from "vue-socialmedia-share";

export default {
  name: 'chatgrp_details',
  components: {
    Facebook,
    Twitter,
    Linkedin,
    Telegram,
    WhatsApp,
    Email,
    Reddit,
    chatgrp_edit,
    group_action_dialog,
    chatgrp_participant_search,
    notification_dialog
  },
  data () {
    return {
      title:'chatgrp_details',
      data:null,
      selectedGroupData:{},
      dialog: false,
      invite_dialog:false,
      exit_group_dialog:false,
      copy_link_tip_show:false,
      share_title: process.env.VUE_APP_GROUP_LINK_SHARE_TITLE,
      share_url: "",
      share_email_body: '',
      show_part_search: false,
      participant_search: '',
      participant_is_admin: false,
      err_msg: '',
      snackbar: false,
      group_type: '1', // 1: Normal chat group, 0: One to One group
      participant_data: [],
      styleObj:{
        'min-height':(window.innerHeight - 80)+'px'
      },
      sheetGrpStyleObj:{
        'backgound-color':'#fafafa',
        'min-height': window.innerHeight+'px'
      },
      chatgrp_edit_dialog:false,
      group_action_dialog:false,
      seleced_participant:{},
      delete_group_dialog:false,
      delete_loading:false,
      delete_second_group_dialog:false,
      message_dialog_open:false,
      message_dialog_data:{},
      notification_dialog:false,
      group_icon_data:{},
      user_contact_list:{},
      show_notification_menu: true
    }
  },
  async mounted() {
    this.get_group_details();
    this.group_icon_data =  await this.getChatgrpIconList;

    if(this.group_icon_data == null){
      this.group_icon_data = {};
    }

    this.user_contact_list = await this.getUserContactListLs;
    if(this.user_contact_list == null){
      this.user_contact_list = {};
    }    
  },
  computed: {
    userData() {
      return this.$store.getters.userData;
    },
    async selectedGroup() {
      return await this.$store.getters.selectedGroup;
    },
    async getChatgrpList(){
      return await this.$store.getters.getChatgrpList;
    },
    filteredParticipants() {
      if(this.data && this.data.participants && this.data.participants.length > 0){
        return this.data.participants;
      }
      return [];
    },
    getSnackBar(){
      return this.$store.getters.getSnackBar;
    },
    getClientDeviceHeight(){
      return this.$store.getters.getClientDeviceHeight;
    },
    getListenerGroupActionResponse(){
      return this.$store.getters.getListenerGroupActionResponse;
    },
    getListenerChatgrpEditResponse(){
      return this.$store.getters.getListenerChatgrpEditResponse;
    },
    getListenerGroupDeleteResponse(){
      return this.$store.getters.getListenerGroupDeleteResponse;
    },
    getListenerUserEditResponse(){
      return this.$store.getters.getListenerUserEditResponse;
    },
    async getChatgrpIconList(){
      return await this.$store.getters.getChatgrpIconList;
    },
    async getUserContactListLs(){
      return await this.$store.getters.getUserContactList;
    },
    async getGroupParticipantsLs () {
      return await this.$store.getters.getGroupParticipants;
    }
  },
  methods: {
    /**
     * get_group_details
     * Get from LS, else via API
     * TODO: This function can be optimised. No need for the loop use the group_id as the object key to get/set data
     */
    async get_group_details() {
      let grp_details = await this.getChatgrpList;
      if(grp_details && grp_details.length > 0) {
        grp_details.forEach(async (group)=>{
          if(group.group_id === await this.selectedGroup){
            this.data = group;
            this.selectedGroupData = group;
            this.group_type = this.data.type;

            if(this.group_type == 0 || this.group_type == '0'){ // 0 is one to one group 
              let participants = this.data.participants.split(',');
              participants.forEach((participant_id) => {
                if(participant_id !== this.userData.user_id){
                  this.getParticipantDetails(participant_id);
                }
              });
            }
            else{
              this.get_group_participants();
            }

            this.share_invite_link_set();
            this.check_user_is_admin();
          }
        });
      }
      else {
        //If group not found in LS then fetch
        this.chatgrp_details();
      }
    },
   /**
    * get_group_participants
    */
    async get_group_participants(){
      let selected_group_id = await this.selectedGroup;

      if(selected_group_id){
        // var post_data = new FormData();
        // post_data.append("chat_user_id", this.userData.user_id);
        // post_data.append("group_id", selected_group_id);

        /*request.curl(this, "group_participant_list", post_data)
        .then(response => {
          if(response.resp_status){
            let participants = response.resp_data;
            this.$set(this.data, 'participants', participants);
            console.log("Data.type ", this.data.type)
            if(this.data.type == '0') {
              // 1-to-1 Message
              this.group_type = '0';
              this.data.group_name = participants[0].user_name;
              this.data.group_icon = participants[0].user_email;
            }
            else{
              this.group_type = '1';
            }

            this.share_invite_link_set();
          }
        }); */
        let participants = await this.getGroupParticipantsLs
        participants = participants[selected_group_id]
        this.$set(this.data, 'participants', participants);
        if(this.data.type == '0') {
          // 1-to-1 Message
          this.group_type = '0';
          this.data.group_name = participants[0].user_name;
          this.data.group_icon = participants[0].user_email;
        }
        else{
          this.group_type = '1';
        }

        this.share_invite_link_set();
      }
    },
    /**
     * chatgrp_details
     */
    async chatgrp_details() {
      let selected_group_id = await this.selectedGroup;

      if(selected_group_id){
        var post_data = new FormData();
        post_data.append("chat_user_id", this.userData.user_id);
        post_data.append("group_id", selected_group_id);

        request.curl(this, "group_view", post_data)
          .then(async response => {
            if(response.resp_status){
              this.data = response.resp_data;
              this.selectedGroupData = response.resp_data;
              this.group_type = this.data.type;
              if(this.group_type == 0 || this.group_type == '0'){ // 0 is one to one group 
                let participants = this.data.participants.split(',');
                participants.forEach((participant_id) => {
                  if(participant_id !== this.userData.user_id){
                    this.getParticipantDetails(participant_id);
                  }
                });
              }
              else{
                await this.get_group_participants();
              }
              this.share_invite_link_set();
              this.check_user_is_admin();
            }
          });
      }
    },
    /**
     * copyShareLink
     * Copy the Data
     */
    copyShareLink(){
      let urlElement = document.querySelector('#share-link-url');
      urlElement.setAttribute('type', 'text');
      urlElement.select();

      try {
        document.execCommand('copy');
        this.copy_link_tip_show = true;
      }
      catch (err) {
        this.copy_link_tip_show = false;
      }
      /* unselect the range */
      urlElement.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();
    },
    /**
     * remove_search
     * Remove the search
     */
    remove_search() {
      this.show_part_search = false;
      this.participant_search = '';
    },
    /**
     * share_invite_link_set
     * Set the Values of Invite Link
     */
    share_invite_link_set(){
      //Build the Share Body for email
      this.share_url = process.env.VUE_APP_GROUP_LINK_SHARE_URL + this.data.group_id;
      this.share_email_body = `Visit ${process.env.VUE_APP_INSTALL_URL} to install the GIDE App. After installing, click this link to join the group ${this.data.group_name} on GIDE.AI\r\n\r\n" + this.share_url + "\r\n\r\n${process.env.VUE_APP_GROUP_LINK_SHARE_TITLE}`;
    },
    /**
     * check_user_is_admin
     * Show Invite link of user is Admin
     */
    check_user_is_admin(){
      //Check if Participant is Admin
      this.participant_is_admin = false;
      this.show_part_search = false;
      
      if(this.data.role == 1 ||  this.data.role =='1'){
        this.participant_is_admin = true;
      }
      else{
        //Show ther expanded search bar in the Participant info area
        this.show_part_search = false; //Enable when Link has to be shown to Admins only
      }
    },
    /**
     * group_action_dialog_open
     * group_action_dialog_open for action of group
     */
    group_action_dialog_open(participant){
      if(participant.participant_id != this.userData.user_id){
        this.seleced_participant = participant;
        this.group_action_dialog=true;
      }
    },
    /**
     * set_group_action
     * Perform Group Actions like Make Admin, Remove Admin, Remove User from Group for self or when fired on socket listen for other participants
     */
    set_group_action(participant_id, action){
      var participant_obj_key = '';
      var participant_obj = {};
      
      if(this.data.participants && this.data.participants.length > 0){
        this.data.participants.forEach((participant , key)=>{
          if(participant.participant_id == participant_id){
            participant_obj_key = key;
            participant_obj = participant;
            return;
          }
        });
      }
      
      if(participant_obj){
        if(action == 0){ //remove group admin
          participant_obj.is_Admin = false;
          this.data.participants[participant_obj_key] = participant_obj;
        }
        else if(action==1){ //make group admin
          participant_obj.is_Admin = true;
          this.data.participants[participant_obj_key] = participant_obj;
        }
        else if(action == 2){ //remove from group
          this.$delete(this.data.participants, participant_obj_key);
          if(participant_id === this.userData.user_id){
            this.err_msg = "You have been removed from the group "+this.data.group_name + " by the group admin";
            this.snackbar = true;
            this.$router.push('/chat');
            return false;
          }
        }
        else if(action == 3){
          //start one to one chat
          this.open_one_to_one_chat(participant_id, participant_obj);
          return false;
        }
        else{
          this.snackbar = true;
          this.err_msg = 'Not valid action';
          return false;
        }
        
        this.check_user_is_admin();
        return participant_obj;
      }
      return false;
    },
    /**
     * group_action
     * Perform Group Actions like Make Admin, Remove Admin, Remove User from Group
     */
    async group_action(participant_id, action){
        let get_group_action = this.set_group_action(participant_id, action);
        if(!get_group_action){
          return false;
        }
        
        this.group_action_dialog = false;
        var post_data = new FormData();
        post_data.append("auth_admin_id", this.userData.user_id);
        post_data.append("group_id", await this.selectedGroup);
        post_data.append('toupdate_user_id', participant_id);
        post_data.append('action', action);

        request.curl(this, "group_action", post_data)
        .then(response => {
          if(!response.resp_status){
            this.snackbar = true;
            this.err_msg = response.resp_msg;
          }
        });
    },
    /**
     * exit_group
     * When User chooses to exit the Group
     * TODO: Possible optimization. No need to iterate. Directly access the group using the Object Key/Group Id
     */
    async exit_group(){
      let grp_details = await this.getChatgrpList;
      let group_id_key = '';
      let group_id = '';
      let selectedGrp = await this.selectedGroup

      //find group id in group details with selected group
      grp_details.forEach(async (group, key)=>{
        if(group.group_id === selectedGrp){
            group_id_key = key;
            group_id = group.group_id;
            return;
        }
      });

      if(group_id){
        var post_data = new FormData();
        post_data.append("chat_user_id", this.userData.user_id);
        post_data.append("group_id", group_id);
        request.curl(this, "group_user_exit", post_data)
        .then(async response => {
          if(response.resp_status){
            //delete selected group from local storage and set remains
            this.$delete(grp_details, group_id_key);

            await this.$store.commit('setChatgrpList', grp_details);

            //remove and render from chatgrp_list component chat group list
            this.$emit('gChatgrpListEvent', group_id);

            //select next group and set after remove selected group
            let setSelectedGroup = "";
            if(grp_details.length > 0){
              setSelectedGroup = grp_details[0].group_id;
              this.$store.commit('setSelectedGroup', setSelectedGroup);
              this.$router.push('/chat');
            }
            else{
              console.log('No group found');
              this.$store.commit('setSelectedGroup', setSelectedGroup);
              this.$router.push("/chatgrp_add");
            }
          }
          else{
            this.snackbar = true;
            this.err_msg = response.resp_msg;
          }
          this.exit_group_dialog = false;
        })
        .catch(err => {
          console.error("Exceprion in exit_group and err: ", err)
        });
      }
      else{
        this.snackbar = true;
        this.err_msg = 'We did not find the group';
      }
    },
    /**
     * open_one_to_one_chat
     */
    async open_one_to_one_chat(participant_id, participant) {
      let grp_details = await this.getChatgrpList;
      let one_to_one_group = this.check_if_one_to_one_group_exists(participant_id, grp_details);

      if(one_to_one_group){
        this.$store.commit("setSelectedGroup", one_to_one_group);
        this.group_action_dialog = false;
        this.$router.push('/chat_message');
      }
      else{
        var group_id = utility.getUniqueId(this.userData.user_id, participant_id);

        var post_data = new FormData();
        post_data.append("chat_user_id", this.userData.user_id);
        post_data.append("group_id", group_id);
        post_data.append("type", '0');

        // keep the o2o grp unpublished until invite accept
        post_data.append("deleted", 2); // 2=unpublished, 1=deleted, 0=published
        post_data.append("invite_page", true);

        var participant_data = [];
        participant_data[0] = {};
        participant_data[0]['is_Admin'] = 1;
        participant_data[0]['participant_id'] = this.userData.user_id;

        participant_data[1] = {};
        participant_data[1]['is_Admin'] = 1;
        participant_data[1]['participant_id'] = participant_id;

        post_data.append('participants', JSON.stringify(participant_data));

        request.curl(this, "group_add", post_data)
        .then(async response => {
          if (response.resp_status) {
            let new_grp_data = response.resp_data;

            new_grp_data.group_name = participant.participant_name;
            new_grp_data.group_icon = participant.participant_image;
            new_grp_data['last_msg'] = response.resp_data_1['text_msg'];
            new_grp_data['last_msg_sender'] = response.resp_data_1['sender_name'];

            if(response.resp_data_1['message_time']){
              new_grp_data['last_msg_time'] = utility.get_message_datetime(response.resp_data_1['message_time'], 'DD/MM/YYYY');
              new_grp_data['last_msg_ts'] = response.resp_data_1['message_time'];
            }
            else{
              new_grp_data['last_msg_time'] = "--:--";
            }

            grp_details.unshift(new_grp_data);

            //save groups to ls;
            await this.$store.commit('setChatgrpList', grp_details);

            //remove and render from chatgrp_list component chat group list
            this.$emit('gChatgrpListEvent', new_grp_data.group_id);

            if (new_grp_data.type == "0" || new_grp_data.type == 0) {
              this.inviteO2O(participant);
              this.group_action_dialog = false;
            }
          }
        });
      }
    },
    /**
     * check_if_one_to_one_group_exists
     */
    check_if_one_to_one_group_exists(participant_id, grp_details) {
      let one_to_one_group = false;
      grp_details.forEach((group)=>{
          if(group.type == 0){
            if(group.participants && group.participants != null){
              let participants = group.participants.split(',');
              let isPresent = participants.some((id) => {return id === participant_id});
              if(isPresent){
                one_to_one_group = group.group_id;
                return;
              }
            }
          }
      });

      return one_to_one_group;
    },
    /**
     * invite_dialog_sharev0
     * deprecated as we are not using the snackbar when launching meshchatapp in iframe on GIDE
     */    
    invite_dialog_sharev0(){ 
      /*
      //for android in app browser
      if(window.androidBridge){
        this.share_url = ""; //Don't Send the URL as it is causing duplicate
        window.androidBridge.inviteLink(this.share_url, this.share_email_body);
      }      
      else
      */
      {
        const shareData = {
          title: 'GIDE.AI',
          text: this.share_email_body,
        }
        
        //If testing on PC/Laptop Browser by simulating the UA, then rename android/iphone to "Desktop"
        //console.log(navigator.userAgent);
        if(navigator.userAgent.toLowerCase().indexOf("android") > -1){
          //android normal browser
          try {
            navigator.share(shareData);
          } 
          catch(err) {
            this.snackbar = true;
            this.err_msg = JSON.stringify(err);
          }
        }
        else if(navigator.userAgent.toLowerCase().indexOf("iphone") > -1 || navigator.userAgent.toLowerCase().indexOf("ipad") > -1){
          //IOS normal browser
          try {
            navigator.share(shareData);
          } 
          catch(err) {
            this.snackbar = true;
            this.err_msg = JSON.stringify(err);
          }
        }
        else {
          //all normal browser normal popup
          this.dialog = true;
        }
      }
    },
    /**
     * invite_dialog_share
     * to be deprecated
     */    
     invite_dialog_share(){ 
      this.dialog = true;  
    },
    /**
     * getParticipantDetails
     *
     */
    getParticipantDetails(participant_id){
      var post_data = new FormData();
      post_data.append("chat_user_id", participant_id);
      this.participant_data = [];
      request.curl(this, "user_profile_view", post_data)
      .then(response => {
        if(response.resp_status){
          this.participant_data = response.resp_data;
        }
        else{
          this.snackbar =  true;
          this.err_msg = response.resp_msg;
        }
      });
    },
    /**
     * delete_group
     * Call Delete
     */     
    async delete_group(){
      var grp_details = await this.getChatgrpList;
      this.delete_loading=true;
      var group_id = await this.selectedGroup;

      var post_data = new FormData();
      post_data.append('group_id', group_id);
      post_data.append('chat_user_id', this.userData.user_id);

      request.curl(this, "group_delete", post_data)
      .then(async response => {
        if(response.resp_status){
          this.$delete(grp_details, this.selectedGroupKey);
          await this.$store.commit('setChatgrpList', grp_details);
          //select next group and set after remove selected group
          let setSelectedGroup = "";
          if(grp_details.length > 0){
            setSelectedGroup = grp_details[0].group_id;
            this.$store.commit('setSelectedGroup', setSelectedGroup);

            this.err_msg = "Group Deleted Successfully";
            this.snackbar = true;

            setTimeout(() => {
              this.$router.push('/chat');
            }, 1000);            
          }
          else{
            //console.log('No group found');

            this.err_msg = "No Groups Available";
            this.snackbar = true;

            this.$store.commit('setSelectedGroup', setSelectedGroup);

            setTimeout(() => {
              this.$router.push("/chatgrp_add");
            }, 1000);
          }
        }
        else{
          this.err_msg = response.resp_msg;
          this.snackbar = true;
        }
        this.delete_loading = false;
        this.delete_second_group_dialog = false;
      });
    },
    /**
    * message_dialog
    */
    async message_dialog(user){
      var is_one_to_one_group_exists = this.check_if_one_to_one_group_exists(user.participant_id, await this.getChatgrpList);
      if(is_one_to_one_group_exists == false){
        this.message_dialog_data = user;
        this.message_dialog_open = true;
      }
      else{
        this.open_one_to_one_chat(user.participant_id, user);
      }
    },
    /*
    * part_search_close
    * */
    part_search_close() {
      this.show_part_search = false;
    },
    /*
    * get_group_icon
    * */
    get_group_icon(group, group_icon_data){
      return media_utility.get_group_icon(group, group_icon_data);
    },
    /*
    * checkStrFirstCharHasAlphabet
    * */
    checkStrFirstCharHasAlphabet(str){
      if(/^[A-Za-z]/.test(str)) {
        return true;
      }
      return false;
    },
    /*
    * get_user_icon
    * */
    get_user_icon(participant){
      var user = {
        user_id : participant.participant_id,
        image : participant.participant_image,
        user_name: participant.participant_name
      }
      var user_icon = media_utility.get_user_icon(user, this.user_contact_list);
      return user_icon;
    },
    /*
    * get_one_to_one_group_icon
    * */
    get_one_to_one_group_icon(participant){
      var user_icon = media_utility.get_user_icon(participant, this.user_contact_list);
      return user_icon;
    },
    /**
     * inviteO2O
     */
     async inviteO2O () {
      this.$router.push('/chat');
    },
   /*
    * notification_setting
    * 
    */    
    notification_setting(){      
      if(window.androidBridge){
        notification_utility.notification_dialog_android(this, this.data.group_id, this.data.group_name)
      }
      else{
        this.notification_dialog = true;
      }
    },
    /*
    * set_participant_admin
    * 
    */ 
    set_participant_admin(user){
      let role = 0;
      if(user.participant_id == this.userData.user_id && user.is_Admin == 1){
        role = 1;
      }
      else{
        role = 0
      }
      if(this.data.role == undefined){
        this.$set(this.data, 'role', role);
        this.check_user_is_admin();
      }
    }
  },
  /**
   * watch
   * Watch the parameter group_id in the URI. When it changes, get the details of that group
   */
  watch: {
    /**
     * selectedGroup
     */
    selectedGroup: function () { 
      this.get_group_details();
    },
    /**
     * getSnackBar
     */
    getSnackBar:function(snackbar){
     this.err_msg = snackbar.msg
     this.snackbar = snackbar.show;
    },
    /**
     * getListenerGroupActionResponse
     */
    getListenerGroupActionResponse(action_data){
      //Trigger for other users
      if(this.userData.user_id != action_data.user_id){
        if(action_data.role != null && action_data.role !=undefined){
          this.data.role = action_data.role;
        }
        
        //if any user add in group from invited group
        if(action_data.participant != undefined && action_data.participant != null){
          this.data.participants.push(action_data.participant);
        }
        else{
          //Group action
          this.set_group_action(action_data.participant_id, action_data.action);
        }
      }
    },
    /**
    * getListenerChatgrpEditResponse
    */
    async getListenerChatgrpEditResponse(group){
      let selectedGroup = await this.selectedGroup;
      if(selectedGroup == group.groupInfo.group_id){
        //Get participant first from this.data group details and overide to geting editable group
        let participants = this.data.participants;
        this.data = group.groupInfo;
        this.selectedGroupData = group.groupInfo;
        //Add participant again for rendring UI.
        this.data.participants = participants;
        if(this.data.participants == null || this.data.participants.length <= 0){
          this.get_group_participants();
        }
      }
    },
    /**
    * getListenerGroupDeleteResponse
    */
    getListenerGroupDeleteResponse(data){
      if(data.user_id != this.userData.user_id){//Check for logged in user
        this.snackbar = true;
        this.err_msg = "You are no longer group member of "+data.group.group_name;
        this.$router.push('/chat');
      }
    },
     /**
    * getListenerChatgrpEditResponse
    */
    async getListenerUserEditResponse(user){
      if(this.group_type == 1 || this.group_type =='1'){
        //1 is group
        if(this.data.participants && this.data.participants != null){ 
          this.data.participants.forEach((participant, key)=>{ 
            if(participant.participant_id === user.user_id){
              this.data.participants[key].participant_name = user.user_name;
              if(user.image){
                this.data.participants[key].participant_image = user.image;
              }
              this.data.participants[key].participant_location = user.country_name; 
              this.data.participants[key].participant_designation = user.designation; 
              this.data.participants[key].participant_company = user.company; 
            }
          })
        }
      }

      if(this.group_type == 0 || this.group_type =='0'){//0 is one to one group
        if(user.image == null && user.image == undefined){
          user.image = this.participant_data.image;
        }
        this.participant_data = user;

        let grp_details = await this.getChatgrpList;
        let selectedGroupId = await this.selectedGroup;
        if(grp_details && grp_details.length > 0) {
          let index = grp_details.findIndex(x => x && x.group_id && x.group_id === selectedGroupId);
          if(grp_details[index]){
            grp_details[index].group_name = user.user_name;
            grp_details[index].group_icon = user.image;
            await this.$store.commit('setChatgrpList', grp_details);
          }
        }
      }
    }
  }
}
